export const bigIntMin = (a, b) => {
    return a < b ? a : b;
};
export const bigIntMax = (a, b) => {
    return a > b ? a : b;
};
export const bigIntAbs = (n) => {
    return n < 0n ? -n : n;
};
